import React, { useContext } from 'react';

//material ui
import { MyOutlinedInputWithButton } from '../../materialUiComponents';

//global state
import { StateContext } from '../../AppStateContext';

const LoginFormContentSelfHostedWeaviate = ({
  classes,
  handleChange,
  handleClick,
}) => {
  //global state
  const state = useContext(StateContext);

  return (
    <div
      className={classes.selfHostedWeaviate}
      style={{ borderColor: '#0075ba' }}
    >
      <MyOutlinedInputWithButton
        state={state}
        id='selfHostedInput'
        label='Self-hosted Weaviate'
        fullWidth={true}
        value={state.connectToWeaviateURI.replace(/ /g, '')}
        helperText={
          state.isLogInSelfHostedIncorrect
            ? 'Error. Please make sure the Weaviate instance is running properly in the format SCHEME://HOST'
            : '(e.g. http://localhost:8080)'
        }
        helperTextId={
          state.isLogInSelfHostedIncorrect
            ? 'weaviateURIErrorMessage'
            : 'selfHostedWeaviateInputHelperText'
        }
        onChange={handleChange}
        endAdornmentOnClick={handleClick}
        endAdornmentLabel={state.isLoginLoading ? 'Connecting' : 'Connect'}
        endAdornmentId='connectToWeaviateButton'
      />
    </div>
  );
};

export default LoginFormContentSelfHostedWeaviate;
